// Cloned from https://github.com/streamich/react-use/blob/master/src/useMedia.ts to circumvent typescript@>4.5.4 issues
// https://github.com/streamich/react-use/issues/2285
import { useEffect, useState } from "../__compat__/react/main.entry.mjs.mjs";
export const isBrowser = typeof window !== 'undefined';
const getInitialState = (query, defaultState) => {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (isBrowser) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (process.env.NODE_ENV !== 'production') {
        console.warn('`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches.');
    }
    return false;
};
export const useMedia = (query, defaultState) => {
    const [state, setState] = useState(getInitialState(query, defaultState));
    useEffect(() => {
        let mounted = true;
        const mql = window.matchMedia(query);
        const onChange = () => {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addEventListener('change', onChange);
        setState(mql.matches);
        return () => {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [query]);
    return state;
};
//# sourceMappingURL=useMedia.mjs.mjs.map